import { render, staticRenderFns } from "./UploadApplicantPhoto.vue?vue&type=template&id=a927b07c&scoped=true"
import script from "./UploadApplicantPhoto.vue?vue&type=script&lang=js"
export * from "./UploadApplicantPhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadApplicantPhoto.vue?vue&type=style&index=0&id=a927b07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a927b07c",
  null
  
)

export default component.exports